export const EVENTS = {
  Add2CartOnProductPageClicked: 'add2cart-on-product-page-clicked',
  Add2CartOnResultClicked: 'add2cart-on-result-clicked',
  AddToWishlistSuccess: 'add-to-wishlist-sucess',
  ApplyNextQuery: 'apply-next-query',
  ApplyRelatedTag: 'apply-related-tag',
  AutoCompleteSuggestionSelected: 'auto-complete-suggestion-selected',
  BannerClicked: 'banner-clicked',
  BannerRightClicked: 'banner-right-clicked',
  BlurSearchInput: 'blur-search-input',
  CallAddToWishlistClientEvent: 'call-add-to-wishlist-client-event',
  CallRemoveFromWishlistClientEvent: 'call-remove-from-wishlist-client-event',
  Checkout: 'checkout',
  ClearFacetsFilters: 'clear-facets-filters',
  ClearInputQuery: 'clear-input-query',
  CloseEmpathyX: 'close-empathy-x',
  ColumnNumberChanged: 'column-number-changed',
  ConfigChanged: 'config-changed',
  CurrencyChanged: 'currency-changed',
  DiscoveryWallBlockShow: 'discovery-wall-block-show',
  DiscoveryWallSuccessWithoutResults: 'discovery-wall-success-without-results',
  DiscoveryWallSuccessWithResults: 'discovery-wall-success-with-results',
  DynamicConfigChanged: 'dynamic-config-changed',
  DynamicFilterCleared: 'dynamic-filter-cleared',
  DynamicFilterSelected: 'dynamic-filter-selected',
  EmpathizeElementSelected: 'empathize-element-selected',
  EmpathizeScroll: 'empathize-scroll',
  EmpathizeSuccess: 'empathize-success',
  EmpathyXCreated: 'empathy-x-created',
  FilterClicked: 'filter-clicked',
  FilterSelected: 'filter-selected',
  FilterSelectedNotAvailable: 'filter-selected-not-available',
  FilterValueChanged: 'filter-value-changed',
  FocusSearchInput: 'focus-search-input',
  GetFallbackFilterResults: 'get-fallback-filter-results',
  GetWishlistSuccess: 'get-wishlist-success',
  InfiniteScroll: 'infinite-scroll',
  InfiniteScrollEmptySearch: 'infinite-scroll-empty-search',
  InfiniteScrollNoResults: 'infinite-scroll-no-results',
  InputArrowPressed: 'input-arrow-pressed',
  InputBlur: 'input-blur',
  InputClicked: 'input-clicked',
  InputEnterPressed: 'input-enter-pressed',
  InputEscapePressed: 'input-escape-pressed',
  InputFocused: 'input-focused',
  InputQueryChanged: 'input-query-changed',
  KeyUp: 'key-up',
  LocaleChanged: 'locale-changed',
  NewQuerySet: 'new-query-set',
  NewVersionDownloaded: 'new-version-downloaded',
  NextQueriesLoadSuccess: 'next-queries-load-success',
  NextQuerySuggestionSelected: 'next-query-suggestion-selected',
  OpenEmpathyX: 'open-empathy-x',
  OpenFinished: 'open-finished',
  PopularSearchSelected: 'popular-search-selected',
  ProductPageDetected: 'product-page-detected',
  PromotedClicked: 'promoted-clicked',
  PromotedRightClicked: 'promoted-right-clicked',
  QuantumEntanglement: 'quantum-entanglement',
  QueryChanged: 'query-changed',
  QueryCleared: 'query-cleared',
  QueryHistoryCleared: 'query-history-cleared',
  QueryHistoryEnabledChanged: 'query-history-enabled-changed',
  QueryHistoryTermRemoved: 'query-history-term-removed',
  QueryHistoryTermSelected: 'query-history-term-selected',
  QuerySet: 'query-set',
  RebindDomEvents: 'rebind-dom-events',
  RecommendationsEmptySearchShowAll: 'recommendations-empty-search-show-all',
  RecommendationsNoResultsShowAll: 'recommendations-no-results-show-all',
  Redirection: 'redirection',
  RedirectionClicked: 'redirection-clicked',
  RelatedTagsLoadSuccess: 'related-tags-load-success',
  RemoveFromWishlistSuccess: 'remove-from-wishlist-success',
  ResultClicked: 'result-clicked',
  ResultClickedWithQueryTracking: 'result-clicked-with-query-tracking',
  ResultRightClicked: 'result-right-clicked',
  ResultsEnd: 'results-end',
  RetrySearch: 'retry-search',
  Scroll: 'scroll',
  ScrollAboutToEnd: 'scroll-about-to-end',
  ScrollDirectionChanged: 'scroll-direction-changed',
  ScrollEnabled: 'scroll-enabled',
  ScrollEnded: 'scroll-ended',
  ScrollOffsetChanged: 'scroll-offset-changed',
  ScrollReachedTop: 'scroll-reached-top',
  ScrollStopped: 'scroll-stopped',
  ScrollTo: 'scroll-to',
  Search: 'search',
  SearchFailed: 'search-failed',
  SearchLocaleChanged: 'search-locale-changed',
  SearchSuccess: 'search-success',
  SearchSuccessWithoutResults: 'search-success-without-results',
  SearchSuccessWithPartialResults: 'search-success-with-partial-results',
  SearchSuccessWithResults: 'search-success-with-results',
  SelectNextQuery: 'select-next-query',
  SetFacetCollapse: 'set-facet-collapse',
  SetHorizontalScrollType: 'set-horizontal-scroll-type',
  SortClicked: 'sort-clicked',
  SortToggleClicked: 'sort-toggle-clicked',
  SpellcheckSelected: 'spellcheck-selected',
  StateLoadedFromCache: 'state-loaded-from-cache',
  StoreChanged: 'store-changed',
  SuggestionSelected: 'suggestion-selected',
  TogglePanel: 'toggle-panel',
  ToggleRelatedTag: 'toggle-related-tag',
  UpdateResult: 'update-result',
  UserAcceptedQueryChanged: 'user-accepted-query-changed',
  ViewPartialResult: 'view-partial-result',
  WindowSizeChanged: 'window-size-changed'
} as const;
